import styled from 'styled-components';

const CustomScrollbar = styled.div.attrs(() => ({
  tabIndex: 0,
}))`
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: currentColor;
  }

  // Firefox support
  @-moz-document url-prefix() {
    scrollbar-color: currentColor transparent;
  }
  overflow-y: auto;
`;

export default CustomScrollbar;
